import CvrSelect from "./CvrSelect";
import CprEntry from "./CprEntry";
import BrokerLandingPage from "./BrokerLandingPage";
import Continue from "./Continue";
import Error from "./Error";
import CoreClient from "./CoreClient";
export default {CvrSelect, CprEntry, BrokerLandingPage, CoreClient, Continue, Error};